var Router = require("base/History");
const _Ensure = require("core/Ensure");
const _Logger = require("core/Logger");

//UTILS
const _FB = require("util/FireBase");
const _Charts = require("util/Charts");
const _Misc = require("util/Misc");

//Views:
const Header = require("view/header/Header");
const Footer = require("view/footer/Footer");

//ENUM:
const ENUM = require("core/Enum");

//HELPERs
const _InputHelper = require("core/InputHelper");

Router.initialize = function(){
    this.init(); // in HISTORY

    this.sectionsId = "#sections";
    this.pages = {};
    this.appStarted = false;
    this.currentPage = null;
    this.currentL2Page = null;

    // create static Components:
    Router.header = new Header();
    Router.footer = new Footer();

    setMainPage();
};

Router.historyChangedHandler = function(){
    setMainPage();
    setPaths();
};

//private:

function setPaths(){
    if(!Router.currentPage)
        return;
    if(Router.currentPage.ready){
        Router.currentPage.pathChanged(Router.l1, Router.l2, Router.l3, Router.l4, Router.l5);
    }

    if(Router.currentPage.requireL2Modules && Router.currentL2Page && Router.currentL2Page.ready){
        Router.currentL2Page.pathChanged(Router.l1, Router.l2, Router.l3, Router.l4, Router.l5);
    }

    Router.header.pathChanged(Router.l1, Router.l2, Router.l3);
    Router.footer.pathChanged(Router.l1, Router.l2, Router.l3);

    _Logger.onPathChange();
}

function pageSetupComplete(){
    Router.pageReady = true;
    if(Router.l1 != 'in'){
        Router.header.show();
        Router.footer.show();
    }
};

function setMainPage() {
    let page = getPageBasedOnLevelPath(0);
    if (!page) {
        _Misc.setOverlay(true, true);
        return;
    }
    if (page.requireInputHelper && !_InputHelper.initialized) {
        _InputHelper.initialize();
    }
    switchPages(page);
    if (page.requireL2Modules) {
        let l2Page = getPageBasedOnLevelPath(1);
        if (!l2Page) {
            _Misc.setOverlay(true, true);
            return;
        }
        switchL2Pages(l2Page);
    }
};

function loadExternalDependencies(){
    let _resume = function(){_Misc.callLater(this.createChildren.bind(this));}.bind(this);
    if(this.requireFirebase && !_FB.initialized){
        _FB.invoke(function(){
            _resume();
        });
    }
    else if(this.requireCharts && !_Charts.initialized){
        _Charts.invoke(function(){
            _resume();
        });
    }
    else{
        _resume();
    }
};

function switchPages(newPage){
    let currentPage = Router.currentPage;
    if(!newPage || (currentPage && newPage.id === currentPage.id))
        return;
    newPage.show();
    if(currentPage){
        currentPage.hide();
    }

    Router.currentPage = newPage;
    setPaths();
    _Misc.setOverlay(false, false);
    if(!Router.pageReady){
        pageSetupComplete();
    }
};

function switchL2Pages(newPage){
    let currentL2Page = Router.currentL2Page;
    if(!newPage || (currentL2Page && newPage.id === currentL2Page.id))
        return;

    newPage.show();
    if(currentL2Page){
        currentL2Page.hide();
    }
    _Misc.setOverlay(false, false);
    Router.currentL2Page = newPage;
    let p = (Router.l1 + Router.l2 + Router.l3);
    if(p === Router.currentL2Page.path)
        return;
    Router.currentL2Page.path = p;
    Router.currentL2Page.pathChanged(Router.l1, Router.l2, Router.l3, Router.l4, Router.l5);
};

function getPageBasedOnLevelPath(pathIdx){
    let lPath = Router.getLevelPath(pathIdx);
    let moduleName = ENUM.VIEWS.getModuleName(lPath);
    if(pathIdx > 0 && moduleName === ENUM.VIEWS.DEFAULT)
        return;
    let page = Router.pages[moduleName];
    if(!page){
        Router.footer.hide();
        _Ensure.load(moduleName, function(Module){
            let sel = (pathIdx === 0) ? Router.sectionsId : Router.currentPage.$self;
            let page = new Module(sel);
            page.hasExternalDependencies = loadExternalDependencies;
            page.readyOnDOM = function(){
                page.readyOnDOM = null;
                Router.pages[moduleName] = page;
                setMainPage();
                _Misc.callLater(function(){
                    if(Router.l1 != "in")
                        Router.footer.show();
                });
            };

        });
        return null;
    }
    return page;
};

module.exports = Router;



// WEBPACK FOOTER //
// ./src/control/core/Router.js